import { CloseCircleOutlined } from "@ant-design/icons";
import { Empty, Modal } from "antd";
import useScrollLock from "../../hooks/useScrollLock";
import PosBankModalInputs from "../profile/PosBankModalInputs";

export default function PosBanksModal({
  open,
  handleOk,
  setOpenModal,
  banks = [],
  updatePosBankList,
  handlePosBankDone = () => {},
  handleCancelPosBank = () => {},
}) {
  function handleCancel() {
    setOpenModal(false);
  }

  // Lock scroll when modal is open
  useScrollLock(open);

  return (
    <div>
      <Modal
        maskClosable={false}
        closeIcon={<CloseCircleOutlined />}
        wrapClassName={"recipe-addons-modal"}
        open={open}
        title={<span className="text-black">POS Banks</span>}
        onOk={handleOk}
        closable={true}
        onCancel={handleCancel}
        footer={[
          <div key={crypto.randomUUID()}>
            {banks.length > 0 && (
              <div className="flex items-center space-x-[10px]">
                <button
                  className="w-[100px] h-[42px] text-sm leading-[16px] text-white bg-[#FA6060] rounded-[5px]"
                  onClick={handleCancelPosBank}
                >
                  Cancel
                </button>
                <button
                  className="w-[100px] h-[42px] text-sm leading-[16px] text-white bg-[#2EC114] rounded-[5px]"
                  onClick={handlePosBankDone}
                >
                  Done
                </button>
              </div>
            )}
          </div>,
        ]}
        style={{ top: 0 }}
      >
        <div className="custom-modal-container">
          <div className="">
            {Boolean(banks) && banks.length > 0 ? (
              <div className="w-full max-h-[65vh] overflow-y-auto">
                <div className="flex items-center space-x-3 font-p_semibold text-[18px] mb-3">
                  <p className="w-[24px]"></p>
                  <p className="w-[300px] text-center">Bank Name</p>
                  <p className="w-[300px]">Display name (In Profile)</p>
                </div>
                {banks.map((bank, idx) => (
                  <div className="w-[calc(100%-20px)] flex items-center gap-x-[60px] mb-3 ml-2" key={bank.posBankId}>
                    <PosBankModalInputs posBankItem={bank} updatePosBankList={updatePosBankList} />
                  </div>
                ))}
              </div>
            ) : (
              <Empty description={false}>
                <div>
                  <p className="font-p_regular font-medium text-gray-500">
                    No <span className="text-red-500">Banks</span> are available at this moment. <br />
                    Please contact <span className="text-[#2EC114]">TableTap</span> authority!
                  </p>
                </div>
              </Empty>
            )}
          </div>
        </div>
      </Modal>
    </div>
  );
}
